exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._25EgCmtrkinUDvFvv1ZqcB{color:#666}.V1GA80qtXlKVdub97RC23{cursor:pointer;margin:3px 5px;padding:3px;border-bottom:2px solid transparent;display:inline-block}.V1GA80qtXlKVdub97RC23:first-child{margin-left:-3px}._3hKIkAan_SSzI-rz3q-amA{font-weight:bold;border-bottom:2px solid #f70}\n", ""]);

// Exports
exports.locals = {
	"TabNav": "_25EgCmtrkinUDvFvv1ZqcB",
	"Tab": "V1GA80qtXlKVdub97RC23",
	"activeTab": "_3hKIkAan_SSzI-rz3q-amA"
};